import Router from '@substrate-system/routes'
import { HomeRoute } from './home.js'
import { ToolsRoute } from './tools.js'
import { AboutRoute } from './about.js'
import { PrivacyRoute } from './privacy.js'
import { TermsRoute } from './terms.js'
import { ToolPlaceholder } from './tools/placeholder.js'
import { LeakRateCalculator } from './tools/leak-rate-calculator.js'
import { LeakCostCalculator } from './tools/leak-cost-calculator.js'
import { SuperheatSubcoolingCalculator } from './tools/superheat-subcooling-calculator.js'
import { ChargeSizeEstimator } from './tools/charge-size-estimator.js'
import { InventoryReconciliationCalculator } from './tools/inventory-reconciliation-calculator.js'
import { Section608RiskEstimator } from './tools/section-608-risk-estimator.js'
import { RefrigerantLogGenerator } from './tools/refrigerant-log-generator.js'
import { EpaAuditChecklist } from './tools/epa-audit-checklist.js'
import { SpreadsheetTemplates } from './tools/spreadsheet-templates.js'
import { RefrigerantPhaseout } from './tools/refrigerant-phaseout.js'
import { RefrigerantDetail } from './tools/refrigerant-detail.js'
import { TOOLS } from '../data/tools.js'

export type AppRoute = {
    href:string;
    text:string;
}

export const routes:ReadonlyArray<AppRoute> = [
    { href: '/#how-it-works', text: 'How it works' },
    { href: '/tools', text: 'Free Tools' },
    { href: '/#faq', text: 'FAQ' },
]

const toolHrefs = new Set(TOOLS.map(t => t.href))

const knownClientRoutes = new Set([
    '/',
    '/privacy',
    '/terms',
    ...routes.map(route => route.href),
    ...toolHrefs,
])

export function createRouter (_state?:unknown):InstanceType<typeof Router> {
    const router = new Router()

    router.addRoute('/', () => {
        return HomeRoute
    })

    router.addRoute('/tools', () => {
        return ToolsRoute
    })

    router.addRoute('/about', () => {
        return AboutRoute
    })

    router.addRoute('/privacy', () => {
        return PrivacyRoute
    })

    router.addRoute('/terms', () => {
        return TermsRoute
    })

    for (const tool of TOOLS) {
        if (tool.href === '/tools/leak-rate-calculator') {
            router.addRoute(tool.href, () => LeakRateCalculator)
        } else if (tool.href === '/tools/refrigerant-leak-cost-calculator') {
            router.addRoute(tool.href, () => LeakCostCalculator)
        } else if (tool.href === '/tools/superheat-subcooling-calculator') {
            router.addRoute(tool.href, () => SuperheatSubcoolingCalculator)
        } else if (tool.href === '/tools/refrigerant-charge-calculator') {
            router.addRoute(tool.href, () => ChargeSizeEstimator)
        } else if (
            tool.href === '/tools/refrigerant-purchase-limit-calculator'
        ) {
            router.addRoute(
                tool.href,
                () => InventoryReconciliationCalculator
            )
        } else if (
            tool.href === '/tools/epa-section-608-risk-estimator'
        ) {
            router.addRoute(
                tool.href,
                () => Section608RiskEstimator
            )
        } else if (
            tool.href === '/tools/refrigerant-log-generator'
        ) {
            router.addRoute(
                tool.href,
                () => RefrigerantLogGenerator
            )
        } else if (
            tool.href === '/tools/epa-audit-checklist'
        ) {
            router.addRoute(
                tool.href,
                () => EpaAuditChecklist
            )
        } else if (
            tool.href === '/tools/spreadsheet-templates'
        ) {
            router.addRoute(
                tool.href,
                () => SpreadsheetTemplates
            )
        } else if (
            tool.href === '/tools/refrigerant-phaseout'
        ) {
            router.addRoute(
                tool.href,
                () => RefrigerantPhaseout
            )
        } else {
            router.addRoute(tool.href, () => ToolPlaceholder)
        }
    }

    router.addRoute(
        '/tools/refrigerant-phaseout/:slug',
        () => RefrigerantDetail
    )

    return router
}

export function getNavRoutes ():AppRoute[] {
    return [...routes]
}

export function isKnownClientRoute (path:string):boolean {
    return knownClientRoutes.has(path)
}
